enum GaCategoryEnum {
	ecommerce = 'ecommerce',
	planners = 'planners',
	nonInteraction = 'non_interaction'
}

export default GaCategoryEnum;
